import Page                                             from '../components/Page'
import { Avatar, Button, Chip, Container, Link, Stack } from '@mui/material'
import Typography                                       from '@mui/material/Typography'
import { Link as RouterLink }       from 'react-router-dom'
import Iconify                      from '../components/Iconify'
import BaseTable                    from '../components/base/BaseTable'
import React                        from 'react'
import { t }                        from 'i18next'
import { useApi }                   from '../utils/api'

export default function Regions() {

  const api = useApi();
  const columns = [
    { field: 'id', headerName: t('ID'), width: 100, filterable: false },
    { field: 'name', headerName: t('Name'), flex: 2, filterable: false, renderCell: (cell) => {
        return (
          <Link
            component={RouterLink}
            size="small"
            to={`/dashboard/regions/${cell.id}`}
          >
            {cell.row.name}
          </Link>
        )
      }, },
    { field: 'active', headerName: t('Active'), width: 100, filterable: false, renderCell: (cell) => {
        return (
          <Chip size={'small'}
                variant={'outlined'}
                color={cell.row.active ? 'primary' : 'default'}
                label={cell.row.active ? t('Active') : t('Inactive')}
          />
        )
      }, },
      { field: 'code', headerName: t('Code'), flex: 2, filterable: false, renderCell: (cell) => {
          return (
            <Typography sx={{ ml: 2, color: 'text.secondary' }} variant="caption">
              {cell.row.code}
            </Typography>
          )
      }, },
  ];

  return (<Page title={t('Regions')}>
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>{t('Regions')}</Typography>
        <Button variant="contained" component={RouterLink} to="/dashboard/regions/create" startIcon={<Iconify icon="eva:plus-fill" />}>
          {t('New region')}
        </Button>
      </Stack>

      <BaseTable
        columns={columns}
        initialSortModel={[{ field: 'name', sort: 'asc' }]}
        loadCallback={async (query, page, pageSize, orderBy) => {
          try {
            return await api.region.list(query, page, pageSize, [], orderBy)
          } catch (e) {
            console.log('Failed to load regions', e)
            return []
          }
        }}
      />
    </Container>
  </Page>);

}